import React, { useState} from 'react';
import { Link } from "react-router-dom";
// import MenuCard from '../components/MenuCard';
import useIsMobile from "../hooks/useIsMobile";
import useIsTablet from "../hooks/useIsTablet";

const Card = ({lang, translations}) => {
  const isDeviceMobile = useIsMobile();
  const isDeviceTablet = useIsTablet();
  const [isHovered, setIsHovered] = useState(false);
  const [isHovered2, setIsHovered2] = useState(false);
  return (
    <main id={'card'} className='card-background'>
      
      <div className={isDeviceMobile ?'flex-column ':'flex-column '}>
        
          <div className='flex h2-title-black  margin-bottom-10 padding-top-10'>
            <h2 className='blue-title'>{translations[lang].cardtitle}</h2>
          </div>
        
        <div className={isDeviceMobile ? 'width80  flex-column around' : isDeviceTablet?'width80 flex-column around'
          // 'title-top-padding around width50'
          : 'width50 flex evently'
          }>
        {/* <MenuCard link={'/menu'} source={'img/menu.png'} alter={"icono carta"}>CARTA</MenuCard>
        <MenuCard link={'/wines'} source={'img/vino.png'} alter={"icono vino"}>VINOS</MenuCard>
        <MenuCard link={'/vermouth'} source={'img/vermut.png'} alter={"icono vermouth"}>VERMOUTH</MenuCard> */}

        <Link className={'no-link padding-bottom-2'} to={'/menu'}>
          {/* <div className={isDeviceMobile ? 'flex-column' : 'flex-column margin-right1'}> */}
          <div className='button1 flex '
              onMouseEnter={() => setIsHovered(true)} // Cambia al pasar el mouse
              onMouseLeave={() => setIsHovered(false)}>
            {/* <div className='carta-image'></div>*/}
            <img  
                  className="menu-icons" 
                  src={isHovered ? "img/icon-food-blue.png" : "img/icon-food.png"} 
                  alt={translations[lang].menucardalt}/>
            <p className='no-wrap-text'>{translations[lang].cardtitle2}</p> 
            
          </div>
        </Link>
        {/* <Link className={'no-link'} to={'/wines'}>
            <div className='flex-column'>
              <div className='vino-image'></div>
              <h3 className='h3-subtitle margin-left-negative'>{translations[lang].winetitle}</h3>
            </div>
          </Link> */}
          <Link className={'no-link padding-bottom-2'} to={'/vermouth'}>
          <div className='button1 flex'
                onMouseEnter={() => setIsHovered2(true)} // Cambia al pasar el mouse
                onMouseLeave={() => setIsHovered2(false)}>
            {/* <div className={isDeviceMobile ? 'flex-column' : 'flex-column margin-left1'}>
              <div className='vermouth-image'></div> */}
              <img className="menu-icons" src={isHovered2 ? "img/icon-wine-blue.png" : "img/icon-wine.png"} alt={translations[lang].drinksiconalt}/>
              <p className='no-wrap-text'>{translations[lang].vermouthtitle}</p>
              
            </div>
          </Link>
        </div>
        <img src={isDeviceMobile ? 'img/imagen-gastronomy-vertical.jpg': 'img/imagen-gastronomy.jpg'} alt={translations[lang].tapasalt} className='img-gastronomy'/>
      </div>
  </main>
  )
}

export default Card